<!-- COWatch -->
<div #coWatch id="coWatch" [ngStyle]="coWatchStyle" cdkDrag>
    <div class="co-watch-tool-bar" cdkDragHandle>
        <!-- Tool Bar -->
        <div class="co-watch-icons" *ngIf="coWatchState == 'meeting'">
            <div class="co-watch-square" [ngClass]="{'co-watch-square-selected': coWatchViewType == 'co-square'}" (click)="changeView('co-square')"></div>
            <div class="co-watch-vert" [ngClass]="{'co-watch-vert-selected': coWatchViewType == 'co-vert'}" (click)="changeView('co-vert')"></div>
            <div class="co-watch-row" [ngClass]="{'co-watch-row-selected': coWatchViewType == 'co-row'}" (click)="changeView('co-row')"></div>
        </div>
        <i class="close-co-watch fa fa-times" (click)="closeCoWatch()"></i>
    </div>

    <!-- Brand Icon & Loader-->
    <div class="co-watch-brand">
        <img src="assets/images/logo.png" />
        <!-- Loader -->
        <div id="coWatchLoader" class="lds-css">
            <div class="dbl-spinner"></div>
            <div class="dbl-spinner"></div>
        </div>
    </div>

    <!-- iFrame -->
    <iframe #coWatchFrame id="coWatchFrame" class="co-frame" allow="camera *;microphone *" allowtransparency="true"></iframe>
</div>